package one.healthium.ui.compose.theme.styles

import androidx.compose.runtime.Composable
import androidx.compose.runtime.Stable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.yellow_2
import org.jetbrains.compose.resources.DrawableResource

@Stable
data class LogWaterControlStyle(
    val footerImage: DrawableResource? = null,
    val saveButtonStyleRef: AppButtonStyleRef = AppButtonStyleRef.PrimaryInverted,
    private val titleStyle: TextStyle? = null,
    private val progressColor: Color? = null,
) {
    val resolvedProgressColor: Color
        @Composable get() = progressColor ?: yellow_2

    val resolvedTitleStyle: TextStyle
        @Composable get() = titleStyle ?: AppTheme.textStyles.secondary_30_500
}
